import { ActionCreator } from 'redux';
import { Dispatch, ThunkAction } from '../../../../../types/actions';
import { boardsListGoogleAnalyticsEvents, BOARDS_LIST_CREATE_FAIL } from './googleAnalyticsEvents';
import { snackbarErrorReload } from '../../../snackbarsStack';

export const onCreateBoardFail: ActionCreator<ThunkAction> =
(e: any) => {
    const action = (dispatch: Dispatch) => {
        dispatch(snackbarErrorReload(true, `Error: ${e.message? e.message: JSON.stringify(e)}`));
        dispatch(boardsListGoogleAnalyticsEvents(BOARDS_LIST_CREATE_FAIL));
    };
    return action;
};
